import MenuAction from 'components/MenuAction';
import { useSelector } from 'react-redux';
import { APPLICANT, getApplicantStatusDisplay, statusKeyToDisplay } from 'utility/lookup';
import { getTimeWithTimeZone, publish } from 'utility/general';
import { SHyperLink } from 'style/CommonStyledComponent';
import { useHistory } from 'react-router-dom';
import usePostApprovalTableAction from 'store/postApproval/usePostApprovalTableAction';
import { documentTypePaths } from 'utility/postApprovalLookUp';

const PostApprovalAction = ({ row, refreshAction = () => {} }) => {
    const postApprovalDetail = usePostApprovalTableAction({ row, fetchPostApproval: refreshAction });

    if (postApprovalDetail.length === 0) {
        return '-';
    }

    return <MenuAction row={row} actions={postApprovalDetail} checkBackEndStatus={true} documentType={'Post'} />;
};

const useApplicationDetail = (masterId) => {
    const rows = useSelector((state) => state.postApproval.draft);
    const userRole = useSelector((state) => state.user.role);
    const history = useHistory();

    const columns = [
        { field: 'subNo', headerName: 'Submission no', width: 200 },
        {
            field: 'documentType',
            headerName: 'Document Type',
            width: 200,
            renderCell: (params) => {
                const display = params.row.documentType;
                const docType = params.row.docType;

                if (documentTypePaths[docType]) {
                    return (
                        <SHyperLink
                            onClick={() => {
                                history.push(`${documentTypePaths[docType] + params.row.id}`);
                            }}
                        >
                            {display}
                        </SHyperLink>
                    );
                }

                return display;
            },
        },
        {
            field: 'statusId',
            headerName: 'Status',
            width: 150,
            valueGetter: (params) => {
                if (userRole === APPLICANT) {
                    return getApplicantStatusDisplay(params.value);
                }
                return statusKeyToDisplay(params.value);
            },
        },
        {
            field: 'updateDtm',
            headerName: 'Last Modification Date',
            width: 200,
            valueGetter: (params) => {
                const { updateDtm } = params.row;

                if (!updateDtm) {
                    return '-';
                }

                return getTimeWithTimeZone(updateDtm).format('YYYY-MM-DD HH:mm:ss');
            },
        },
        {
            field: 'expiryDate',
            headerName: 'Expiry Date',
            width: 200,
            valueGetter: (params) => {
                const { expiryDate } = params.row;

                if (!expiryDate) {
                    return '-';
                }

                return getTimeWithTimeZone(expiryDate).format('YYYY-MM-DD');
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 100,
            disableItemSort: true,
            renderCell: (params) => {
                return (
                    <PostApprovalAction
                        row={params.row}
                        refreshAction={() => {
                            publish({ topic: 'refresh' });
                        }}
                    />
                );
            },
        },
    ];

    return { rows, columns };
};

export default useApplicationDetail;
